<template>
    <Header />
    <RouterView />

    <Footer />

    <Modals />
</template>

<script setup>
import { computed, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';

import Header from './components/Header/Header.vue';
import Footer from './components/Footer/Footer.vue';
import Modals from '@/components/modals/Modals.vue';

// import stores from '@/stores';
import { keepAwake } from '🔗/utils/utils'

const { t } = useI18n();
// const tg = stores.tg();
const others = stores.others();
const user = stores.user();
// const nav = stores.nav();
const locale = stores.locale();

const ready = async () => {
    others.setReady(true);
};

onMounted(async () => {
    document.addEventListener('visibilitychange', keepAwake);
    keepAwake();

    await stores.user().checkHasToken();


    if (stores.user().token) {
        stores.appPlugin().syncProfiles();
    }
});

onBeforeUnmount(() => {
    document.removeEventListener('visibilitychange', keepAwake);
});
</script>


<style scoped lang="scss">
    .direction-rtl {
       
    }
</style>
